import { EMPTY_CELL } from '@/lib/utils';

// Renders a user's group memberships as colored pills, capping the visible
// count and rolling the rest into a "+N" chip (full list via title tooltip).
// Shared by EmployeesListPage.js and UserGroupsPage.js (EIP-206 / EIP-270) so
// the two pages can't drift on color-fallback behavior. `hideWhenEmpty` lets a
// page that renders this inline among other optional badges (which render
// nothing when absent) match that convention instead of showing a table-style
// empty-cell placeholder.
export function GroupBadges({ groups, maxVisible = 3, hideWhenEmpty = false }) {
  if (!groups || groups.length === 0) {
    return hideWhenEmpty ? null : (
      <span className="text-sm text-gray-400 dark:text-gray-500">{EMPTY_CELL}</span>
    );
  }

  const visible = groups.slice(0, maxVisible);
  const overflow = groups.length - visible.length;

  return (
    <div
      className="flex flex-wrap items-center gap-1"
      title={groups.map((g) => g.name).join(', ')}
    >
      {visible.map((group) => (
        <span
          key={group.id}
          className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium"
          style={{
            color: group.color || 'hsl(var(--primary))',
            borderColor: group.color ? `${group.color}55` : 'hsl(var(--border))',
            backgroundColor: group.color ? `${group.color}14` : 'transparent',
          }}
        >
          {group.name}
        </span>
      ))}
      {overflow > 0 && (
        <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
          +{overflow}
        </span>
      )}
    </div>
  );
}
